import InfoOnMultipleLine from './InfoOnMultipleLine';
import { InfoOnMultipleLineProps, InfoOnMultipleLineValueProps } from './types';

export type { InfoOnMultipleLineProps, InfoOnMultipleLineValueProps };
export default InfoOnMultipleLine;
